<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="giftCode._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ giftCode.title }}</h3>
            <p class="text-center">{{ giftCode.isActive ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات کد هدیه</h4>
          </div>
          <div class="widget-body">
            <form id="groupForm" class="form-horizontal">
              <!-- group name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام کد هدیه</label>
                <div class="col-lg-6">
                  <input type="text" name="groupName" class="form-control" v-model="giftCode.title" />
                </div>
              </div>

              <!-- gift code -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">کد هدیه</label>
                <div class="col-lg-6">
                  <input name="minPlayCount" class="form-control" v-model="giftCode.code" />
                </div>
              </div>

              <!-- license days -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">روزهای افزایش اشتراک</label>
                <div class="col-lg-6">
                  <input type="number" name="minPlayCount" class="form-control" min="1" v-model="giftCode.days" />
                </div>
              </div>

              <!-- added coins -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد سکه های هدیه</label>
                <div class="col-lg-6">
                  <input type="number" name="minPlayCount" class="form-control" min="1" v-model="giftCode.coins" />
                </div>
              </div>

              <!-- is max usage enabled -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >وضعیت حداکثر استفاده از کد</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="giftCode.isMaxActive">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- max usage count -->
              <div v-if="giftCode.isMaxActive" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">بیشترین تعداد استفاده</label>
                <div class="col-lg-6">
                  <input type="number" name="maxUseCount" class="form-control" min="1" v-model="giftCode.maxUseCount" />
                </div>
              </div>

              <!-- used count -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد استفاده تا الان</label>
                <div class="col-lg-6">
                  <input type="number" name="minPlayCount" class="form-control" disabled v-model="giftCode.usedCount" />
                </div>
              </div>

              <!-- is Active -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت کد هدیه</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="giftCode.isActive">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is expirabble -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تاریخ انقضا</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="giftCode.expireAble">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- expire date -->
              <div v-if="giftCode.expireAble" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تاریخ انقضا</label>
                <!-- <div class="group material-input"> -->
                <p>تاریخ انقضا</p>
                <date-picker
                  name="startDate"
                  type="datetime"
                  inputFormat="YYYY-MM-DD HH:mm"
                  display-format="jYYYY-jMM-jDD HH:mm"
                  format="YYYY-MM-DD HH:mm"
                  locale="fa,en"
                  altFormat="MM-DD-YYYY HH:mm"
                  v-model="giftCode.expireDate"
                ></date-picker>
              </div>

              <!-- groups -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">گروه ها</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="giftCode.groups" multiple>
                    <option value="" disabled>انتخاب کنید</option>
                    <option v-for="group in groups" :key="group._id" :value="group._id">{{ group.title }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">آیتم های فروشگاه</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="giftCode.shopItems" multiple>
                    <option value="" disabled>انتخاب کنید</option>
                    <option v-for="item in shopItems" :key="item._id" :value="item._id">{{ item.title }}</option>
                  </select>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/Gifts">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import giftService from '../../../../services/gift';
import shopService from '../../../../services/shop';
import groupService from '../../../../services/UsersRulePermissions';
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  name: 'groupdetail',
  data() {
    return {
      giftCode: {
        groups: [],
        shopItems: [],
      },
      shopItems: [],
      groups: [],
      id: null,
    };
  },
  created() {
    this.getGroups();
    this.getShopItems();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getGift(this.id);
    }
  },
  methods: {
    async getShopItems() {
      try {
        const resData = await shopService.getRawItems();
        this.shopItems = resData;
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        const resData = await groupService.getGroups({});
        this.groups = resData;
      } catch (err) {
        console.log(err);
      }
    },
    async getGift(id) {
      try {
        const giftServiceInstance = new giftService();
        const giftCode = await giftServiceInstance.giftById({ id });
        this.giftCode = giftCode;
      } catch (err) {
        console.log(err);
      }
    },
    async save() {
      const body = this.giftCode;
      let id;
      try {
        if (this.id) {
          body.id = this.id;
          await new giftService().updateGift(body);
          id = this.id;
          window.notif({ mssg: 'تغییرات انجام شد', isError: false });
        } else {
          const group = await new giftService().createGift(body);
          id = group._id;
          this.id = id;
          window.notif({ mssg: 'کد جدید با موفقیت ساخته شد', isError: false });
        }

        this.getGift(id);
      } catch (err) {
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },
  },
};
</script>
